/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FilterWithShowNonEffective
 */
export interface FilterWithShowNonEffective {
    /**
     * 
     * @type {boolean}
     * @memberof FilterWithShowNonEffective
     */
    showNonEffective?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FilterWithShowNonEffective
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof FilterWithShowNonEffective
     */
    term?: string | null;
}

export function FilterWithShowNonEffectiveFromJSON(json: any): FilterWithShowNonEffective {
    return FilterWithShowNonEffectiveFromJSONTyped(json, false);
}

export function FilterWithShowNonEffectiveFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilterWithShowNonEffective {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'showNonEffective': !exists(json, 'showNonEffective') ? undefined : json['showNonEffective'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'term': !exists(json, 'term') ? undefined : json['term'],
    };
}

export function FilterWithShowNonEffectiveToJSON(value?: FilterWithShowNonEffective | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'showNonEffective': value.showNonEffective,
        'limit': value.limit,
        'term': value.term,
    };
}


